"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgGenderMale(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    width: 11,
    height: 20
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#179FE3",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.233 5.79l1.928.265a1 1 0 00.136.009H5.67a1 1 0 00.134-.01l2.012-.271a1 1 0 011.053 1.384L6.221 13.36a1 1 0 00-.08.393v3.565a1 1 0 01-1 1H3.972a1 1 0 01-1-1v-3.59a1 1 0 00-.085-.404L.182 7.184a1 1 0 011.05-1.394z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.614,
    cy: 2.159,
    r: 2.159
  })));
}

var MemoSvgGenderMale = /*#__PURE__*/React.memo(SvgGenderMale);
var _default = MemoSvgGenderMale;
exports["default"] = _default;